import { useMemo, useState } from 'react';

const WD = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December'];
const ymd = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
const time = (ts) => (ts ? new Date(ts).toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' }) : '');

export default function FlightCalendar({ flights = [], onSelect }) {
  const [cursor, setCursor] = useState(() => { const n = new Date(); return new Date(n.getFullYear(), n.getMonth(), 1); });

  const byDate = useMemo(() => {
    const m = {};
    for (const f of flights) {
      const key = String(f.flight_date || '').slice(0, 10);
      if (!key) continue;
      (m[key] = m[key] || []).push(f);
    }
    Object.values(m).forEach((list) => list.sort((a, b) => String(a.depart_at || '').localeCompare(String(b.depart_at || ''))));
    return m;
  }, [flights]);

  const year = cursor.getFullYear();
  const month = cursor.getMonth();
  const startOffset = new Date(year, month, 1).getDay();
  const daysInMonth = new Date(year, month + 1, 0).getDate();
  const todayKey = ymd(new Date());

  const cells = [];
  for (let i = 0; i < startOffset; i++) cells.push(null);
  for (let d = 1; d <= daysInMonth; d++) cells.push(new Date(year, month, d));
  while (cells.length % 7 !== 0) cells.push(null);

  const goToday = () => { const n = new Date(); setCursor(new Date(n.getFullYear(), n.getMonth(), 1)); };

  return (
    <div className="cal">
      <div className="cal__head">
        <button className="cal__nav" onClick={() => setCursor(new Date(year, month - 1, 1))} aria-label="Previous month">‹</button>
        <div className="cal__title">{MONTHS[month]} {year}</div>
        <button className="cal__nav" onClick={() => setCursor(new Date(year, month + 1, 1))} aria-label="Next month">›</button>
        <button className="cal__today" onClick={goToday}>Today</button>
      </div>
      <div className="cal__grid cal__grid--head">
        {WD.map((w) => <div key={w} className="cal__wd">{w}</div>)}
      </div>
      <div className="cal__grid">
        {cells.map((d, i) => {
          if (!d) return <div key={i} className="cal__cell cal__cell--empty" />;
          const key = ymd(d);
          const list = byDate[key] || [];
          return (
            <div key={i} className={'cal__cell' + (key === todayKey ? ' cal__cell--today' : '')}>
              <div className="cal__date">{d.getDate()}</div>
              <div className="cal__events">
                {list.map((f) => (
                  <button
                    key={f.id}
                    className={'cal__event cal__event--' + f.status}
                    onClick={() => onSelect && onSelect(f)}
                    title={`${f.aircraft || ''} ${f.departure || '?'}→${f.arrival || '?'}${f.pilot ? ' · ' + f.pilot : ''}`}
                  >
                    {f.depart_at && <span className="cal__time">{time(f.depart_at)}</span>}
                    <span className="cal__ev-main">{f.aircraft || f.job_number}{(f.departure || f.arrival) ? ` ${f.departure || '?'}→${f.arrival || '?'}` : ''}</span>
                  </button>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
